import { jsxs as g, jsx as j } from "react/jsx-runtime";
import { forwardRef as V } from "react";
import c from "clsx";
import { tagVariants as p } from "./Tag.variants.js";
const f = p.definition().defaultVariants, n = p, S = V(
  ({
    as: N = "span",
    className: l,
    classes: o,
    children: d,
    colorScheme: t = f.colorScheme,
    iconEnd: m,
    iconStart: i,
    variant: r = f.variant,
    ...e
  }, x) => {
    const b = n.root({
      className: c(o == null ? void 0 : o.root, l),
      colorScheme: t,
      variant: r
    }), u = n.icon({
      className: o == null ? void 0 : o.icon,
      colorScheme: t,
      variant: r
    }), y = n.label({
      className: o == null ? void 0 : o.label,
      colorScheme: t,
      variant: r
    }), a = {
      className: u,
      size: "sm"
    };
    return /* @__PURE__ */ g(N, { ref: x, className: b, ...e, children: [
      i && i(a),
      /* @__PURE__ */ j("span", { className: y, children: d }),
      m && m(a)
    ] });
  }
);
export {
  S as Tag
};
